import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
// import { COMMON_KEY_VALUE } from '../common/data.common';
import { DateTimeFormat, LANGUAGE, LOCAL_STORAGE } from '../../shared/constants/common.const';
import { DateFormat } from '../../shared/constants/common.type';
import { Util } from '../../shared/helpers/util';
import { DateUtils } from '../../shared/utils/date-utils.static';

@Injectable({
  providedIn: 'root'
})
export class DateTimeFormatService {
  private util = new Util();
  // private language = this.util.getSecureStorage(LOCAL_STORAGE.I18N);
  private _language: string;

  set language(value: string) {
    this._language = value;
  }

  get language(): string {
    return this._language = this.util.getSecureStorage(LOCAL_STORAGE.I18N);
  }

  constructor(private datePipe: DatePipe) {}

  public static getDateTimeFormat() {}

  getDateTimeFormat(value: string, mode?: DateFormat): string {
    let result: string;
    switch (mode) {
      case 'hhmm':
            result = DateUtils.getTimeAsString(value, false);
            break;
      case 'hhmmss':
            result = DateUtils.getTimeAsString(value, true);
            break;
      case 'yyyymmdd':
            result = this.getDateFormatByLanguage(value);
            break;
      case 'yyyymmddhhmm':
            result = this.getDateTimeFormatByLanguage(value);
            break;
      case 'yyyymmddhhmmss':
            result = this.getDateTimeFormatByLanguage(value, true);
            break;
      case 'yyyy-mm-dd':
            result =  DateUtils.getDateAsString(value);
            break;
      default:
            result = this.getDateFormatByLanguage(value);
    }
    if (result) {
      return result.toUpperCase();
    }
  }

//   public getDayFormat(day: number, suffix?: boolean): string {
//     let result = (day < 10 ? '0' : '') + day;
//     for (let i = 1; i <= 31; i++) {
//       if ( Number(COMMON_KEY_VALUE.monthlyDayCodes[i].key) === day ) {
//         if (suffix) {
//           result =  COMMON_KEY_VALUE.monthlyDayCodes[i].value;
//         }
//       }
//     }
//     // let suffixValue = 'th';
//     // if (day === 1 || day === 21 || day === 31) {
//     //     suffixValue = 'st';
//     // } else if (day === 2 || day === 22) {
//     //     suffixValue = 'nd';
//     // } else if (day === 3 || day === 23) {
//     //    suffixValue = 'rd';
//     // }
//     // let result = (day < 10 ? '0' : '') + day;
//     // if (suffix) {
//     //     result += suffixValue;
//     // }
//     return result;
//   }

  private getDateFormatByLanguage(value): string {
      const date = DateUtils.getDateAsString(value);
      if (this.isENORKM()) {
        // KHR
            if ( this.isKM() ) {
              return this.datePipe.transform(date, DateTimeFormat.ddmmyyyy);
            }
            return this.datePipe.transform(date, DateTimeFormat.ddmmmyyyy);
      } else {
          return this.datePipe.transform(date, DateTimeFormat.yyyymmdd);
      }
  }
  private getDateTimeFormatByLanguage(value: string, isIncludeSecond?: boolean): string {
      const date = DateUtils.getDateAsString(value, true);
      const datetime = DateUtils.getDateAsString(value, true, true);
      let formatDate = DateTimeFormat.ddmmyyyyhhmm;
      if (!this.isEN()) {
        if (isIncludeSecond) {
          formatDate = DateTimeFormat.yyyymmddhhmmss;
        } else {
          formatDate =  DateTimeFormat.yyyymmddhhmm;
        }
      } else if ( this.isKM() ){
        if (isIncludeSecond) {
          formatDate = DateTimeFormat.ddmmyyyyhhmmss;
        } else {
          formatDate = DateTimeFormat.ddmmyyyyhhmm;
        }
      } else {
        if (isIncludeSecond) {
          formatDate = DateTimeFormat.ddmmmyyyyhhmmss;
        } else {
          formatDate = DateTimeFormat.ddmmmyyyyhhmm;
        }
      }
      if ( isIncludeSecond ) {
        return  this.datePipe.transform(datetime, formatDate);
      }
      return  this.datePipe.transform(date, formatDate);
  }

  private isENORKM(): boolean {
    if (
      this.language === LANGUAGE.I18N_EN ||
      this.language === LANGUAGE.I18N_KM
    ) {
      return true;
    }
    return false;
  }

  private isKM(): boolean {
    if ( this.language === LANGUAGE.I18N_KM ) {
      return true;
    }
    return false;
  }
  private isEN(): boolean {
    if ( this.language === LANGUAGE.I18N_EN ){
      return true;
    }
    return false;
  }
}
